import { render, staticRenderFns } from "./LatestRoles.vue?vue&type=template&id=4e0e4104"
import script from "./LatestRoles.vue?vue&type=script&lang=js"
export * from "./LatestRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports